// extracted by mini-css-extract-plugin
export default {"divider":"divider--lI5UVCPf3YHzeeFFx8VX"};